import { render, staticRenderFns } from "./ReturnList.vue?vue&type=template&id=5fa9ba26&scoped=true&lang=html"
import script from "./ReturnList.vue?vue&type=script&lang=js"
export * from "./ReturnList.vue?vue&type=script&lang=js"
import style0 from "./ReturnList.vue?vue&type=style&index=0&id=5fa9ba26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa9ba26",
  null
  
)

export default component.exports